import React from "react";
import "./styles.scss";

import NavigationLink from "components/atoms/navigationLink/index.jsx";

export default class Nav extends React.Component {
  render() {
    return (
      <div className="nav">
        <NavigationLink to="/" linkText="Usados seleccionados" />
        <NavigationLink to="/outlet" linkText="Outlet" />
        <NavigationLink to="/usados-sin-rodar" linkText="Semi nuevos" />
        <NavigationLink to="/compramos-tu-usado" linkText="Vender" />
        <NavigationLink to="/pedi-tu-usado" linkText="Buscamos tu usado" />
        {/* <NavigationLink to="/usados-buenos-aires" linkText="Usados Buenos Aires" /> */}
      </div>
    );
  }
}
